import AxiosNode from '@/services/api/node/axios_node'

export default {
  search: (params) => AxiosNode.get('/history/elastic/search', { params }),
}
